export default __webpack_public_path__ + "static/media/alexander-gibson-resume-2022-4.35490503.pdf";